import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'foundations-theming/utils';
import { useAppSelector } from '../../../reducers';
import { billingNameKeySelector, skuIdHasBundledProductsSelector } from '../../../selectors/ProductsSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Bold = styled.span.withConfig({
  displayName: "BundleIncludesDisplay__Bold",
  componentId: "sc-17up45i-0"
})(["font-weight:600;margin-top:10px;display:inline-block;"]);
export const BundleIncludesDisplay = ({
  skuId
}) => {
  const hasBundles = useAppSelector(state => {
    return skuIdHasBundledProductsSelector(state, {
      skuId
    });
  });
  const billingNameKey = useAppSelector(state => billingNameKeySelector(state, {
    skuId
  }));
  if (!hasBundles) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("span", {
      style: {
        marginTop: '4px',
        display: 'block'
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.includes"
      })
    }), /*#__PURE__*/_jsx("span", {
      style: {
        marginLeft: '20px',
        display: 'inline-block'
      },
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: `pricing-pages.products.${billingNameKey}.bundleIncludes_jsx`,
        elements: {
          Bold,
          br: () => /*#__PURE__*/_jsx("br", {})
        }
      })
    })]
  });
};